// extracted by mini-css-extract-plugin
module.exports = {"loading":"PageLoading_loading__1xKSJ","loadingShrink":"PageLoading_loadingShrink__8jc4X"};